var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThankYouTeba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-thank-you") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0066b3 } \n\t\t.s1 { fill: #ec6500 } \n\t\t.s2 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m40 80c-22.1 0-40-17.9-40-40 0-22.1 17.9-40 40-40 22.1 0 40 17.9 40 40 0 22.1-17.9 40-40 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m39.6 57.5q0.7-0.1 1.3-0.3 0.3-0.1 0.6-0.2 0.3 0 0.5-0.1 0.3-0.1 0.6-0.2 0.3-0.1 0.5-0.2 0.3-0.1 0.6-0.3 0.2-0.1 0.5-0.2 0.3-0.1 0.5-0.2 0.3-0.2 0.6-0.3 1-0.5 2-1.2 1-0.6 1.9-1.3 0.9-0.7 1.7-1.6 0.9-0.8 1.6-1.7 0.8-0.9 1.5-1.8 0.6-1 1.2-2 0.5-1 1-2.1 0.4-1.1 0.8-2.2 0.3-1 0.5-2l-13.9-13.9q-0.9-0.9-1.9-1.6-1-0.7-2.2-1.1-1.1-0.5-2.4-0.8-1.2-0.2-2.4-0.2-1.3 0-2.5 0.2-1.2 0.3-2.4 0.8-1.1 0.4-2.2 1.1-1 0.7-1.9 1.6c-4.9 5-4.9 13 0 17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m40 18.3q2.1 0 4.2 0.4 2.1 0.5 4.1 1.3 2 0.8 3.7 2 1.8 1.2 3.3 2.7c8.5 8.5 8.5 22.1 0 30.6-8.5 8.5-22.1 8.5-30.6 0-8.5-8.5-8.5-22.1 0-30.6q1.5-1.5 3.3-2.7 1.7-1.2 3.7-2 2-0.8 4.1-1.3 2.1-0.4 4.2-0.4zm9.9 15q-0.5 0.1-0.9 0.4l-12.2 9.1-5.6-5.6c-1.2-1.3-3.6 1.1-2.4 2.3l6.7 6.7c0.6 0.5 1.5 0.6 2.2 0.1l13.3-10c1.1-0.8 0.4-2.9-1-3q0 0 0 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThankYouTeba);
export default __webpack_public_path__ + "static/media/icon-thank-you-teba.92f9c5c624e75fd110730324513925eb.svg";
export { ForwardRef as ReactComponent };